import { gql } from "@apollo/client";

// ─── User-level 2FA enrollment / management ────────────────────────────────

export const START_TWO_FACTOR_SETUP = gql`
  mutation StartTwoFactorSetup {
    startTwoFactorSetup {
      secret
      otpauthUrl
      qrCodeDataUrl
      issuer
      accountName
    }
  }
`;

export const ENABLE_TWO_FACTOR = gql`
  mutation EnableTwoFactor($input: EnableTwoFactorInput!) {
    enableTwoFactor(input: $input) {
      enabled
      recoveryCodes
      user {
        id
        email
        twoFactor {
          enabled
          enabledAt
          recoveryCodesRemaining
        }
      }
    }
  }
`;

export const DISABLE_TWO_FACTOR = gql`
  mutation DisableTwoFactor($input: DisableTwoFactorInput!) {
    disableTwoFactor(input: $input) {
      id
      email
      twoFactor {
        enabled
        recoveryCodesRemaining
      }
    }
  }
`;

export const REGENERATE_TWO_FACTOR_RECOVERY_CODES = gql`
  mutation RegenerateTwoFactorRecoveryCodes($input: EnableTwoFactorInput!) {
    regenerateTwoFactorRecoveryCodes(input: $input) {
      recoveryCodes
      user {
        id
        twoFactor {
          enabled
          recoveryCodesRemaining
        }
      }
    }
  }
`;

// ─── Login-time challenge step ─────────────────────────────────────────────

export const VERIFY_TWO_FACTOR_CHALLENGE = gql`
  mutation VerifyTwoFactorChallenge($input: VerifyTwoFactorChallengeInput!) {
    verifyTwoFactorChallenge(input: $input) {
      token
      refreshToken
      expiresIn
      requiresTwoFactor
      challengeToken
      twoFactorSetupRequired
      user {
        id
        email
        firstName
        lastName
        role
        isEmailVerified
        avatar
        preferences {
          theme
          notifications {
            email
            push
          }
        }
        twoFactor {
          enabled
          enabledAt
          recoveryCodesRemaining
        }
        organizations {
          id
          name
          domain
          security {
            twoFactorRequired
            twoFactorRequiredRoles
            twoFactorEnforcedAt
          }
          members {
            role
            user {
              id
              email
              firstName
              lastName
            }
          }
          subscription {
            plan
            status
            billingCycle
            currentPeriodStart
            currentPeriodEnd
            usage {
              code
              count
              limit
              limitExceeded
              lastUsageAt
            }
          }
          billingCurrency
          outboundCallingEnabled
          isShopifyManaged
          shopifyBillingRequired
          shopifyShopDomain
        }
        createdAt
        updatedAt
      }
    }
  }
`;

// ─── Org-level enforcement (owner only) ─────────────────────────────────────

export const UPDATE_ORGANIZATION_SECURITY_POLICY = gql`
  mutation UpdateOrganizationSecurityPolicy(
    $input: UpdateOrganizationSecurityPolicyInput!
  ) {
    updateOrganizationSecurityPolicy(input: $input) {
      id
      name
      security {
        twoFactorRequired
        twoFactorRequiredRoles
        twoFactorEnforcedAt
        twoFactorEnforcedBy
      }
    }
  }
`;
